import { render } from "./ExtendedValueTypes.vue?vue&type=template&id=a3d48076"
import script from "./ExtendedValueTypes.vue?vue&type=script&lang=js"
export * from "./ExtendedValueTypes.vue?vue&type=script&lang=js"
script.render = render

export default script